// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__wwS8O","col":"styles_col__q_Bdy"};